import { ExtraCharge, ExtraChargesType } from '@/redux/modules/billingManagement/extraCharges/extraCharges.types';
import { handleResponse, makeGet, makePost } from '@/redux/api/helpers';

type GetExtraChargeTypesParams = {
    authToken: string;
    deployment: string;
};

type GetExtraChargeTypesResponse = {
    error: boolean;
    payload: ExtraChargesType[];
};

export const getExtraChargeTypes = ({ authToken, deployment }: GetExtraChargeTypesParams) =>
    new Promise<GetExtraChargeTypesResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'admin/billing/extra-charge-types',
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });

        request.end((err, response) =>
            handleResponse({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type PostExtraChargeParams = {
    /**
     * How much is the house being charged for
     */
    amount: number;
    authToken: string;
    /**
     * When the charge is due.
     * Must be formatted in `yyyy-mm-dd`
     * @example 2026-10-16
     */
    billingDate: string;
    /**
     * The id of the associated catalog, if any
     */
    catalogId?: number;
    /**
     * The name of the charge type
     *
     * NOTE: This does NOT use an id, the names of the charge types are all unique.
     * @see useGetChargeTypeOptions
     */
    chargeType: ExtraChargesType['name'];
    deployment: string;
    /**
     * Description of the charge.
     * For example, why the charge was added, or other relevant information.
     */
    description?: string;
    houseId: number;
};

type PostExtraChargeResponse = {
    error: boolean;
    payload: ExtraCharge;
};

export const postExtraCharge = ({ authToken, deployment, houseId, ...body }: PostExtraChargeParams) =>
    new Promise<PostExtraChargeResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `admin/house/${houseId}/billing/extra-charge`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });
        request.send(body);
        request.end((err, response) =>
            handleResponse({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
